import { useState, useEffect } from 'react';

export const useMarkdownContent = (filePath, previewLines = 1) => {
  const [markdownContent, setMarkdownContent] = useState('');
  const [previewContent, setPreviewContent] = useState('');

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '';
    fetch(`${baseUrl}/${filePath}`)
      .then((res) => res.text())
      .then((text) => {
        setMarkdownContent(text);
        const preview = text.split('\n').slice(0, previewLines).join('\n');
        setPreviewContent(preview);
      })
      .catch(console.error);
  }, [filePath, previewLines]);

  return { markdownContent, previewContent };
};
